import { getUsersForSchool, reloadUsersForSchool } from '@action/auth.action'
import { getExtendedAction } from '@action/extended-ngrx-action'
import { redirectAngularRouter } from '@action/redirect.action'
import { showCompleteRosterModal } from '@action/roster-page/roster-page.actions'
import {
  savePrivacyAgreementAccepted,
  savePrivacyAgreementAcceptedError,
  savePrivacyAgreementAcceptedSuccess
} from '@action/user/user-api.action'
import { HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { FirstLevelDir } from '@domain/route/app-routes.domain'
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { selectSelectedSchoolId } from '@selector/auth.selector'
import { ModalService } from '@service/material/modal.service'
import { UserApiService } from '@service/network/user.service'
import { MIN_UI_RELATED_STATE_THROTTLE_TIME } from '@shared/constants'
import { RosterPageViewModel } from '@view/pages/roster-page/roster-page.view'
import { catchError, debounceTime, map, mergeMap, of, tap } from 'rxjs'

@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private modalService: ModalService,
    private userApiService: UserApiService
  ) {}
  reloadUsersForSchool$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(reloadUsersForSchool),
        concatLatestFrom((_) => this.store.select(selectSelectedSchoolId)),
        tap(([_, schoolId]) => {
          this.store.dispatch(getUsersForSchool(getExtendedAction(schoolId)))
        })
      ),
    { dispatch: false }
  )
  handleShowCompleteRosterModal$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(showCompleteRosterModal),
        tap(() => {
          this.modalService.showTransitionModal(
            RosterPageViewModel.getAppearedActiveUsersCongratulationsModal(
              () => {
                this.store.dispatch(
                  redirectAngularRouter(getExtendedAction(FirstLevelDir.dashboard))
                )
              },
              () => {}
            )
          )
        })
      ),
    { dispatch: false }
  )
  savePrivacyAgreementAccepted$ = createEffect(() =>
    this.actions$.pipe(
      ofType(savePrivacyAgreementAccepted),
      debounceTime(MIN_UI_RELATED_STATE_THROTTLE_TIME),
      mergeMap((action) =>
        this.userApiService.savePrivacyAgreement(action.payload).pipe(
          map(() => {
            return savePrivacyAgreementAcceptedSuccess()
          }),
          catchError((e: HttpErrorResponse) => {
            return of(savePrivacyAgreementAcceptedError(getExtendedAction(e)))
          })
        )
      )
    )
  )
}
